import { z } from "zod";
export const DataClassificationLevelV1Schema = z.enum([
    "PUBLIC",
    "INTERNAL",
    "CONFIDENTIAL",
    "RESTRICTED",
]);
export const DataClassificationRecordV1Schema = z
    .object({
    schemaVersion: z.literal("data-classification-record.v1.0"),
    dataClassId: z.string().min(1),
    level: DataClassificationLevelV1Schema,
    encryptionAtRest: z.enum(["PROVIDER_MANAGED", "NOT_APPLICABLE"]),
    encryptionInTransit: z.literal("TLS_REQUIRED"),
    accessLogRequired: z.literal(true),
})
    .strict();
export const DEFAULT_DATA_CLASSIFICATION_REGISTRY = [
    {
        schemaVersion: "data-classification-record.v1.0",
        dataClassId: "tenant_business_graph",
        level: "CONFIDENTIAL",
        encryptionAtRest: "PROVIDER_MANAGED",
        encryptionInTransit: "TLS_REQUIRED",
        accessLogRequired: true,
    },
    {
        schemaVersion: "data-classification-record.v1.0",
        dataClassId: "agency_session_token_hash",
        level: "RESTRICTED",
        encryptionAtRest: "PROVIDER_MANAGED",
        encryptionInTransit: "TLS_REQUIRED",
        accessLogRequired: true,
    },
];
export function dataClassificationRegistryCovers(dataClassId) {
    return DEFAULT_DATA_CLASSIFICATION_REGISTRY.some((row) => row.dataClassId === dataClassId);
}
//# sourceMappingURL=data-classification-registry.js.map